import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {FormStatus, LanguagesService, ServiceCode} from '../../../../core';
import {GridFormComponent} from '../grid-form.component';

@Component({
  selector: 'gc-detail-modal',
  templateUrl: './detail-modal.component.html',
  styleUrls: ['./detail-modal.component.less']
})
export class DetailModalComponent implements OnInit {

  constructor(public lang: LanguagesService) { }
  FormStatusEnum = FormStatus;
  @Input()
  get visible(): boolean {
    return this.dialogVisible;
  }
  set visible(v) {
    this.dialogVisible = v;
  }
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title = '';
  @Input() iconName = 'add';
  // @Input() view = true;
  @Input() form: GridFormComponent;

  dialogVisible = false;
  maxHeight = 100;
  // serial = null;

  ngOnInit(): void {
    this.resize();
  }

  close(): void {
    this.visibleChange.emit(false);
    this.form.cancel();
    this.dialogVisible = false;
  }

  save(): void {
    this.form.save(this.form.data[this.form.currentIndex].serial, (success, ) => {
      if (success === ServiceCode.Success) {
        // this.dialogVisible = false;
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(_): void {
    this.resize();
  }

  resize(): void {
    this.maxHeight = window.innerHeight - 200;
  }

  next(): void {
    this.form.currentIndex < this.form.data.length - 1 ? this.form.currentIndex = this.form.currentIndex + 1 :
      this.form.currentIndex = this.form.data.length - 1;
    if (this.form.status === FormStatus.Edit) {
      this.form.startEdit(this.form.data[this.form.currentIndex].serial, {ctrlKey: true});
    }
  }

  previous(): void {
    this.form.currentIndex > 0 ? this.form.currentIndex = this.form.currentIndex - 1 : this.form.currentIndex = 0;
    if (this.form.status === FormStatus.Edit) {
      this.form.startEdit(this.form.data[this.form.currentIndex].serial, {ctrlKey: true});
    }
  }
}
